// extracted by mini-css-extract-plugin
export default {"button":"styles_button__whLc-","hasText":"styles_hasText__pG4ep","text":"styles_text__iE+8R"};